import { IUser } from '@shared/interfaces/user.interface';
import { ICategory } from '@shared/interfaces/categories.interface';
import { ILocation } from '@shared/interfaces/location.interface';

export class Category implements ICategory {
  public id: string;
  public name: string;
  public responsibleUsers?: Partial<IUser>[];
  public subLocations?: Partial<ILocation>[];

  constructor(partial: Partial<ICategory>) {
    Object.assign(this, partial);
  }

}
